import React from "react";

import StatusHistoryBx, { StatusHistoryBoxProps } from "./StatusHistoryBx";

interface StatusHistoryThreadProps {
  data: Array<StatusHistoryBoxProps> | null;
}

const StatusHistoryThread = ({data}: StatusHistoryThreadProps) => {

  if ( !data || data.length === 0 ) {
    return (
      <div>
        <p>No status history</p>
      </div>
    )
  }

  return (
    <ul>
      {data.map((item, index) => (
        <li key={`${item.ticket_id}-${index}`}>
          <img
            src="https://res.cloudinary.com/dt0wfaxft/image/upload/v1641983339/Icon_ionic-md-checkmark-circle_sdwlpv.svg"
            alt=""
          />
          <StatusHistoryBx {...item}/>
        </li>
      ))}
    </ul>
  );
};

export default StatusHistoryThread;
